export function PtBadge({ name, colors, className = "" }) {
  if (!name) return null;
  const c = colors?.[name] || "#64748B";
  return (
    <span data-testid={`pt-badge-${name}`} className={`shrink-0 rounded px-1 text-[9px] font-bold leading-[14px] uppercase ${className}`}
      style={{ color: c, backgroundColor: `${c}1A`, border: `1px solid ${c}55` }}>{name}</span>
  );
}

export const colorMap = (companies) => Object.fromEntries((companies || []).map((c) => [c.name, c.color]));
